export type FeatureAnnouncementContent = {
  announcementTitle: string;
  announcementSubtitle: string;
  announcementId: string;
  featureTitle: string;
  featureDescription: string;
  image: {
    src: string;
    alt: string;
  };
  featureItems: Array<{
    title: string;
    testId: string;
    description: string;
  }>;
  featureFlag?: string;
};

export const isFeatureAnnouncementContent = (json: unknown): json is FeatureAnnouncementContent => {
  if (typeof json !== 'object' || json === null) return false;
  const value = json as Record<string, unknown>;

  if (
    typeof value.announcementTitle !== 'string' ||
    typeof value.announcementSubtitle !== 'string' ||
    typeof value.announcementId !== 'string' ||
    typeof value.featureTitle !== 'string' ||
    typeof value.featureDescription !== 'string'
  ) {
    return false;
  }

  if (typeof value.image !== 'object' || value.image === null) return false;
  const image = value.image as Record<string, unknown>;
  if (typeof image.src !== 'string' || typeof image.alt !== 'string') return false;

  if (!Array.isArray(value.featureItems)) return false;
  const hasValidFeatureItems = value.featureItems.every((item) => {
    if (typeof item !== 'object' || item === null) return false;
    const featureItem = item as Record<string, unknown>;
    return (
      typeof featureItem.title === 'string' &&
      typeof featureItem.testId === 'string' &&
      typeof featureItem.description === 'string'
    );
  });
  if (!hasValidFeatureItems) return false;

  return value.featureFlag === undefined || typeof value.featureFlag === 'string';
};
